import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', {
    width: '100%',
    height: '100%',
    display: 'flex',
    borderRadius: '2.4rem',
    border: `1px solid #B3BBC7`,
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1.2rem 2rem'
})

export const InputWrapper = styled('input', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    fontWeight: 400,
    lineHeight: '2.4rem',
    width: '100%',
    height: '100%',
    border: 'none',
    outline: 'none',
    borderRadius: '2.4rem',
    // placeholder color
    '&::placeholder': {
        color: '#B3BBC7'
    }
}))
